module.exports = __webpack_public_path__ + "static/media/online-shopper.60143f4c.jpg";